var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.$slots.default)?_c('label',{staticClass:"block mb-1 text-sm w-full md:w-4/12 md:text-right md:mb-0 md:mt-2 md:px-2 poppins"},[_vm._t("default")],2):_c('span',{staticClass:"w-full md:w-4/12 md:text-right md:mb-0 md:mt-2 md:px-2"})}
var staticRenderFns = []

export { render, staticRenderFns }